import NonAuthorizedPage from './nonAuthorizedPage';

export default NonAuthorizedPage;
